<template>
  <div id="market-detail">
    <v-layout align-center justify-center row wrap>
      <v-flex md4 sm6 v-if="groups" xs12>
        <div class="caption">วางจำหน่ายที่</div>
        <div class="headline my-2">{{ groups.nameTha }}</div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    qrcodeId: {
      type: String
    }
  },
  data() {
    return {
      groups: []
    }
  },
  async created() {
    const states = await this.fetchData()
    this.getGroups(states)
  },
  methods: {
    async fetchData() {
      try {
        const response = await this.axios.get(`cropperz/qrcode/${this.qrcodeId}`)
        return response.data[0]
      } catch (error) {
        throw new Error(error)
      }
    },
    async getGroups(states) {
      try {
        const response = await this.axios.get(`cropperz/groups/details/${states.marketId}`)
        if (response.data) {
          this.groups = response.data[0]
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
